export const YOU_TUBE_DATA = "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=US&key=AIzaSyC813eobFPHq1EAcKFCPOmJiHo7Aorozco" ; 

export const MY_API_KEY = `AIzaSyC813eobFPHq1EAcKFCPOmJiHo7Aorozco` ;
